import { render, staticRenderFns } from "./GAIptalEtme.vue?vue&type=template&id=66785f4c&scoped=true"
import script from "./GAIptalEtme.vue?vue&type=script&lang=js"
export * from "./GAIptalEtme.vue?vue&type=script&lang=js"
import style0 from "./GAIptalEtme.vue?vue&type=style&index=0&id=66785f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66785f4c",
  null
  
)

export default component.exports